import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useEffect } from "react";

const rowStyle = {
  "&:last-child td, &:last-child th": { border: 0 },
  "&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body": {
    py: "16px",
    borderBottom: "1px solid #F3F3F3",
  },
};

const tableStyle = {
  minWidth: 470,
  "& .MuiTableBody-root th": { fontWeight: 700 },
  "& .MuiTableCell-root.MuiTableCell-head": {
    borderBottom: "1px solid #F3F3F3",
    fontWeight: 700,
    p: "6px 16px",
    fontSize: "14px",
  },
  "& .MuiTableCell-root.MuiTableCell-body": {
    color: "primary.dark",
    fontSize: "14px",
    py: "6px",
  },
};

type DetailAnswerType = {
  answer: any;
};

const DetailAnswer: React.FC<DetailAnswerType> = (props) => {
  useEffect(() => {}, [props.answer]);
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "none",
        width: "100%",
        height: "100%",
      }}
    >
      <Table sx={tableStyle} aria-label="simple table">
        <TableBody>
          {props.answer?.answers &&
            Object.entries(props.answer?.answers).map((ans: any, index: number) => {
              return (
                <TableRow sx={rowStyle} key={index}>
                  <TableCell component={"th"} width={'50%'}>{ans[0]}</TableCell>
                  <TableCell>
                    {Array.isArray(ans[1]["value"]) ? ans[1]["value"].join("、") : ans[1]["value"]}
                    {ans[1]["children_answers"] &&
                      Object.entries(ans[1]["children_answers"]).map((chil_ans: any, childIdx: number) => {
                        return (
                          <div key={childIdx}>
                            {/* {chil_ans[1]['value'].length > 1 ? } */}
                            {typeof chil_ans[1]["dependent_answers"][0] === "object" ? (
                              Array.isArray(chil_ans[1]["value"]) &&
                              chil_ans[1]["value"].map((chilAnsValue: any, daIndex: number) => {
                                return <div key={daIndex}>{chilAnsValue}: {chil_ans[1]["dependent_answers"][0][chilAnsValue] || ''}</div>;
                              })
                            ) : (
                              <>
                                {chil_ans[1]["value"].join("、")}
                                {chil_ans[1]["dependent_answers"][0] ? `（${chil_ans[1]["dependent_answers"].join("、")}）` : ""}
                              </>
                            )}
                          </div>
                        );
                      })}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default DetailAnswer;
